import { createContext, useContext } from "react";

type KeyboardEventSinkContext = {
  activate: () => void;
  deactivate: () => void;
};

export const KeyboardEventSinkContext = createContext<KeyboardEventSinkContext | undefined>(undefined);

KeyboardEventSinkContext.displayName = "KeyboardEventSinkContext";

export const useKeyboardEventSink = () => {
  const context = useContext(KeyboardEventSinkContext);

  if (!context) {
    throw new Error(`Expected KeyboardEventSinkContext in ancestor tree.`);
  }

  return context;
};
